module.exports = __webpack_public_path__ + "fb09a99f.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/paper-plane.png
// module id = 1315
// module chunks = 8